<template>
  <Layout>
    <template #head>
      <Basics :basics="resume.basics" />
    </template>
    <template #main>
      <Skills :skills="resume.skills" :categorized-skills="resume.categorizedSkills" />
      <Education :education="resume.education" />
      <Work :work="resume.work" workTitle="Experience" />
      <Publications :publications="resume.publications" />
      <Projects :projects="resume.projects" />
      <Volunteer :volunteer="resume.volunteer" />
      <Certificates :certificates="resume.certificates" />
      <Awards :awards="resume.awards" />
      <References :references="resume.references" />
      <Languages :languages="resume.languages" />
      <Additional :additional="resume.additional" />
    </template>
  </Layout>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import resume from '@/schemas/json_resume.json'
import Basics from '../../components/BasicsBaylor.vue'
import Work from '../../components/Work.vue'
import Education from '../../components/Education.vue'
import Projects from '../../components/Projects.vue'
import References from '../../components/References.vue'
import Awards from '../../components/Awards.vue'
import Certificates from '../../components/Certificates.vue'
import Publications from '../../components/Publications.vue'
import Languages from '../../components/Languages.vue'
import Additional from '../../components/Additional.vue'
import Layout from './Layout.vue'
export default defineComponent({
  name: 'ResumeBasic',
  components: {
    Basics,
    Work,
    Education,
    Projects,
    References,
    Awards,
    Certificates,
    Publications,
    Languages,
    Additional,
    Layout,
  },
  props: {
    resume: {
      type: Object,
      required: true,
      default: () => resume,
    },
  },
})
</script>
